export const SITE_URL = 'https://akasan-ml.tech'
export const SITE_NAME = 'Akasan ML'
export const SITE_DESCRIPTION =
  '機械学習エンジニア Akasan のポートフォリオサイト。機械学習・クラウド・GPU に関する技術ブログやプロダクトを公開しています。'
export const AUTHOR_NAME = 'Daisuke Akagawa'
export const DEFAULT_OG_IMAGE = `${SITE_URL}/profile_image.jpeg`
